export const DEFAULT_COLOR_THEME: ColorThemeDefaultOptions = 'light';
